import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './reducers'
import thunkMiddleware from 'redux-thunk'
import { getClientConfig } from '../utils/helpers'

const devToolsWrapper = composedMiddleware => {
  const { ENV } = getClientConfig()
  return ENV === 'dev' ? composeWithDevTools(composedMiddleware) : composedMiddleware
}

export function initializeStore(initialState = {}) {
  return createStore(rootReducer, initialState, devToolsWrapper(applyMiddleware(thunkMiddleware)))
}
